import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'declineInvitation', [
  'INIT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  slug: [
    { type: 'payload', selector: ['userId'] },
    'programs',
    'invitations',
    { type: 'payload', selector: ['invitationId'] },
  ],
  type: 'delete',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/declineInvitation.js